import React, { Fragment, useEffect, useState, useContext } from 'react'
import { getFilexIdproceso, getFilexIdprocesoColaborador } from '../../../../../services/files'
import { KTIcon, toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import { showDeleteMessage, showMessage } from '../../../../../shared/Alerts'
import { downloadFileS3 } from '../../../../../services/files'


export const ListDocuments = ({ id }) => {
    const [documento, setDocumento] = useState([])

    useEffect(() => {
        refetchData()
    }, [])

    const refetchData = () => {
        getFilexIdprocesoColaborador(id)
            .then((response) => {
                if (response.success) {
                    setDocumento(response?.data)
                } else {
                    console.log(response.msg)
                }
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const handleDownload = async (keyname, filename) => {
        const partes = filename.split('.')
        const extension = partes[partes.length - 1]

        downloadFileS3(keyname, extension)
            .then((response) => {
                if (response.success) {
                    const link = document.createElement('a')
                    link.href = response.data
                    link.download = filename
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)

                    showMessage('success', '¡Buen trabajo!', response.message)
                } else {
                    console.log(response)
                    showMessage('error', 'Hubo un error', response.error)
                }
            })
            .catch((error) => {
                console.log(error)
                showMessage('error', 'Hubo un error', error.message)
            })
    }

    const handleView = (id, keyname, filename) => {
        const partes = filename.split('.')
        const extension = partes[partes.length - 1]

        const url = `/configuracion/documentos/view/${id}`
        window.open(url, '_blank')
    }

    return (
        <>
            <div className='table-responsive min-vh-100'>
                <table
                    id='kt_table_kitingreso'
                    className='table align-middle table-row-bordered fs-6 table-hover'
                >
                    <thead>
                        <tr className='text-start fw-bolder fs-7 text-uppercase gs-0 bg-primary text-white'>
                            {/* <th className=''></th> */}
                            <th className='text-start px-2'>Nombre</th>
                            <th className='text-start'>Tipo</th>
                            {/* <th className='text-start'></th> */}
                            <th className='text-end p-3'>Acciones</th>
                        </tr>
                    </thead>
                    <tbody className='text-gray-600 fw-bold'>
                        {documento && (
                            <>
                                {Object.keys(documento).map((key) => (
                                    <Fragment key={key}>
                                        {/* <tr>
                      <td></td>
                      <td className='text-start '>
                        <a
                          href='# '
                          className='text-dark fw-bold text-hover-primary mx-7 mb-1 fs-6'
                        >
                          {key}
                        </a>
                      </td>
                      <td></td>
                      <td></td>
                    </tr> */}
                                        {documento[key].map((item, index) => (
                                            <Fragment key={item._id}>
                                                <tr>
                                                    {/* <td></td> */}
                                                    <td className='text-start'>
                                                        {item.type === 'PLANTILLA' ? (
                                                            <img
                                                                src={toAbsoluteUrl('/media/svg/files/doc.svg')}
                                                                className='h-20px mx-10'
                                                            />
                                                        ) : (
                                                            <img
                                                                src={toAbsoluteUrl('/media/svg/files/pdf.svg')}
                                                                className='h-20px mx-10'
                                                            />
                                                        )}

                                                        <a href='# ' className='text-dark fw-bold text-hover-primary mb-1 fs-6'>
                                                            {item.name}
                                                        </a>
                                                    </td>
                                                    <td>
                                                        <a href='# ' className='text-dark fw-bold text-hover-primary mb-1 fs-6'>
                                                            {item.type}
                                                        </a>
                                                    </td>
                                                    {/* <td>
                            <a href='# ' className='text-dark fw-bold text-hover-primary mb-1 fs-6'>
                              {item.type_document}
                            </a>
                          </td> */}
                                                    <td className='text-end text-muted fw-semibold'>
                                                        <div className='d-flex justify-content-end flex-shrink-0'>
                                                            <a
                                                                href='#'
                                                                onClick={() => handleDownload(item.keyname, item.filename)}
                                                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                            >
                                                                <KTIcon iconName='cloud-download' className='fs-3' />
                                                            </a>
                                                            <a
                                                                href='#'
                                                                onClick={() => handleView(item._id, item.keyname, item.filename)}
                                                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                            >
                                                                <KTIcon iconName='eye' className='fs-3' />
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </Fragment>
                                        ))}
                                    </Fragment>
                                ))}
                            </>
                        )}
                    </tbody>
                </table>
            </div>
        </>
    )
}
